export const FINANCIAL = 'Financial';
export const MANAGE = 'Manager';
export const FACTORY = 'FACTORY';
export const LOGISTICS = 'Logística';




// WEBPACK FOOTER //
// ./src/js/user-groups.js